var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppleAppStore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 29,
    viewBox: "0 0 25 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5364 15.3744C20.5509 14.3311 20.8511 13.3081 21.4089 12.4007C21.9666 11.4933 22.764 10.7308 23.7266 10.1844C23.1151 9.37791 22.3083 8.71423 21.3704 8.24604C20.4324 7.77785 19.3892 7.51805 18.3235 7.48726C16.0501 7.26694 13.8462 8.7433 12.6878 8.7433C11.5069 8.7433 9.72327 7.50914 7.80261 7.54562C6.56027 7.58268 5.34952 7.91625 4.28831 8.51382C3.2271 9.1114 2.35164 9.9526 1.74722 10.9555C-0.871013 15.141 1.08195 21.2923 3.58999 24.6756C4.84482 26.3323 6.31136 28.1828 8.23029 28.1172C10.1081 28.0453 10.8094 27.0116 13.076 27.0116C15.3217 27.0116 15.9796 28.1172 17.9375 28.0755C19.9525 28.0453 21.222 26.4114 22.4328 24.739C23.3344 23.5586 24.0281 22.2539 24.4884 20.8734C23.3178 20.4162 22.3188 19.651 21.616 18.6731C20.9132 17.6953 20.5377 16.548 20.5364 15.3744Z",
    fill: "#2B3F5F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8405 5.26171C17.9391 4.04395 18.4804 2.47873 18.3493 0.898438C16.6708 1.06121 15.1204 1.80191 14.0069 2.97295C13.4625 3.54503 13.0455 4.21058 12.7799 4.93154C12.5142 5.6525 12.405 6.41474 12.4586 7.17469C13.2981 7.18267 14.1287 7.01465 14.8877 6.68329C15.6467 6.35193 16.3144 5.86587 16.8405 5.26171Z",
    fill: "#2B3F5F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleAppStore);
export default __webpack_public_path__ + "static/media/apple-app-store.0c90ccdaecae6cc86a5c9561ae98da3b.svg";
export { ForwardRef as ReactComponent };